module.exports = __webpack_public_path__ + "img/IOTA.df4b8f93.png";